<template>
  <div class="row">
    <!-- WON DEALS SUMMARY -->
    <div class="col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
            <h5>Won Deals Performance</h5>
            <small class="text-muted">Click any stat to drill down</small>
          </div>
        </div>

        <div class="card-body">
          <div class="text-center mb-4">
            <p class="mb-1 fw-medium">Total Won Value</p>
            <div class="d-flex align-items-center justify-content-center">
              <h3 class="me-2">{{ fmtMoney(won.total_value_won, currency) }}</h3>
              <span class="badge badge-soft-success border-success border rounded-pill">
                {{ fmtNum(won.counts?.Won || 0) }} Deals
              </span>
            </div>
          </div>

          <div class="stage-chart-main">
            <div class="deal-stage-chart">
              <div
                v-for="(pct, key) in won.percent"
                :key="key"
                class="text-center d-flex align-items-center justify-content-center flex-column rounded-circle chart-stage hover-pointer"
                :class="stageClass(key)"
                @click="drillStage(key)"
              >
                <span class="d-block text-white mb-1">{{ key }}</span>
                <h6 class="text-white">{{ pct }}%</h6>
              </div>

              <div
                v-if="!Object.keys(won.percent || {}).length"
                class="text-muted small text-center"
              >
                No won-stage breakdown available
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- RECENT FOLLOW UPS -->
    <div class="col-xl-6 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
            <h5>Recent Follow Up</h5>
            <small class="text-muted">Click person to filter by owner</small>
          </div>
        </div>

        <div class="card-body">
          <div
            v-for="u in followUps"
            :key="u.id"
            class="d-flex align-items-center justify-content-between mb-4 hover-pointer"
            @click="drillOwner(u.id)"
          >
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="avatar flex-shrink-0">
                <img
                  v-if="u.avatar_url"
                  :src="u.avatar_url"
                  class="rounded-circle border border-2"
                  alt="img"
                />
                <span v-else class="avatar-title rounded-circle bg-primary text-white">
                  {{ initials(u.name) }}
                </span>
              </a>
              <div class="ms-2">
                <h6 class="fs-14 fw-medium text-truncate mb-1">
                  {{ u.name || "—" }}
                </h6>
                <p class="fs-13 text-muted mb-0">
                  {{ u.last_follow_up || "No follow up date" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="btn btn-light btn-icon btn-sm">
                <i class="ti ti-arrow-right fs-16"></i>
              </a>
            </div>
          </div>

          <div v-if="!followUps.length" class="text-muted small">
            No recent follow-ups for selected filters.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useDealDashboardStore } from "@/stores/dealDashboardStore";

const dash = useDealDashboardStore();

const won = computed(() => dash.wonStage || {});
const followUps = computed(() => dash.recentFollowUps || []);
const currency = computed(() => dash.kpis?.currency || "KES");

function fmtMoney(v, cur = "KES") {
  const n = Number(v || 0);
  return `${cur} ${n.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
}
function fmtNum(v) {
  return Number(v || 0).toLocaleString();
}

function initials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .map((x) => x[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function stageClass(key) {
  const map = {
    Conversion: "bg-secondary",
    Calls: "bg-danger",
    Email: "bg-warning",
    Chats: "bg-success",
    Won: "bg-primary",
  };
  return map[key] || "bg-info";
}

async function drillStage(stageName) {
  if (stageName === "Won") {
    dash.filters.status = "Won";
  } else {
    dash.setStageByName(stageName);
  }
  await dash.fetchDashboard();
}

async function drillOwner(ownerId) {
  dash.filters.owner_id = ownerId;
  await dash.fetchDashboard();
}
</script>

<style scoped>
.chart-stage {
  width: 110px;
  height: 110px;
  margin: 10px;
}
.hover-pointer {
  cursor: pointer;
}
</style>
